import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { debounceTime, distinctUntilChanged, filter, finalize, startWith, switchMap, tap } from 'rxjs';
import { Deposito } from 'src/app/shared/models/deposito';
import { Direccion } from 'src/app/shared/models/direccion';
import { Distribuidor } from 'src/app/shared/models/distribuidor';
import { FormControl } from '@angular/forms';
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Proceso } from 'src/app/shared/models/proceso';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Stock } from 'src/app/shared/models/stock';
import { StockPedidosDialogComponent } from 'src/app/shared/components/stock-pedidos-dialog/stock-pedidos-dialog.component';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { UbicacionAlmacenamiento } from 'src/app/shared/models/ubicacionAlmacenamiento';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { ReportesService } from 'src/app/shared/services/reportes.service';
import { StockDistribuidores } from 'src/app/shared/models/stockDistribuidores';
import { StockDistribuidoresLotes } from 'src/app/shared/models/stockDistribuidoresLotes';

@Component({
  selector: 'app-inventarios',
  templateUrl: './inventarios.component.html'
})
export class InventariosComponent implements OnInit, AfterViewInit {

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private productosService: ProductosService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    public exportExcelService: ExcelService,
    private reportesSevice: ReportesService) { }

  depositos: Deposito[] = [];
  direcciones: Direccion[] = [];
  depositoSeleccionado: Deposito;
  bloquearSeleccionDeposito: boolean = false;
  selectedDeposito: any = -1;
  productoSeleccionado: Stock;
  direccionSeleccionada: Direccion;
  almacenSeleccionado: UbicacionAlmacenamiento;
  almacenes: UbicacionAlmacenamiento[] = [];
  displayedColumnsConsolidados = ['acciones', 'idCompania', 'idSalesOrg', 'idProducto', 'producto', 'cantidadDisponible', 'cantidadDisponibleVigente', 'cantidadPedidos', 'cantidadDisponibleVenta'];
  displayedColumnsPorLote = ['idUbicacionAlmacenamiento', 'idLote', 'cantidadDisponible', 'cantidadTransito', 'cantidadTransitoDevolucion', 'idUnidadMedidaBase', 'estado', 'fechaVencimientoLote'];
  dataSourceConsolidados = new MatTableDataSource<Stock>();
  dataSourcePorLote = new MatTableDataSource<Stock>();

  @ViewChild('matSortConsolidados') matSortConsolidados: MatSort;
  @ViewChild('matSortPorLote') matSortPorLote: MatSort;
  @ViewChild('matPaginatorPorLote') matPaginatorPorLote: MatPaginator;
  @ViewChild('matPaginatorConsolidados') matPaginatorConsolidados: MatPaginator;


  distribuidorSeleccionado: Distribuidor;
  filteredOptions: any;
  formControlAutocomplete = new FormControl('');
  hint: string = ""
  isLoading = false;
  minLengthTerm = 2;


  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }

  public Etiquetas: {
    FiltrarDeposito: string,
    FiltrarDireccion: string,
    Buscar: string,
    SinRegistros: string,
    Titulo: string,
    Almacen: string
    Headers: {
      IdCompania: string,
      IdSalesOrg: string,
      IdProducto: string,
      Producto: string,
      CantidadDisponible: string,
      CantidadDisponibleVigente: string,
      CantidadPedidos: string,
      CantidadDisponibleVenta: string
      FechaVencimientoLote: string,
      Estado: string,
      IdLote: string,
      IdUnidadMedidaBase: string,
      CantidadTransito: string,
      CantidadTransitoDevolucion: string

    }


  }


  ngAfterViewInit() {
    this.dataSourceConsolidados.paginator = this.matPaginatorConsolidados;
    this.dataSourceConsolidados.sort = this.matSortConsolidados;
    this.dataSourceConsolidados.sort.disableClear = true;

    this.dataSourcePorLote.paginator = this.matPaginatorPorLote;
    this.dataSourcePorLote.sort = this.matSortPorLote;
    this.dataSourcePorLote.sort.disableClear = true;

  }

  ngOnInit() {
    if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADM LOCAL') && !this.loggedService.isInRole('ADMVENTAS')
      && !this.loggedService.isInRole('LOGISTICA') && !this.loggedService.isInRole('DISTRIBUIDOR') && !this.loggedService.isInRole('VENDEDOR')) {
      this.router.navigateByUrl('');
    }

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Ver: this.configService.tooltips.Ver
    }
    this.Etiquetas = {
      Titulo: this.configService.etiquetas.Inventarios.Titulo,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Buscar: this.configService.etiquetas.Buscar,
      FiltrarDeposito: this.configService.etiquetas.Inventarios.FiltrarDeposito,
      FiltrarDireccion: this.configService.etiquetas.Inventarios.FiltrarDireccion,
      Almacen: this.configService.etiquetas.StorageLocation,
      Headers: {

        IdProducto: this.configService.etiquetas.Inventarios.IdProducto,
        Producto: this.configService.etiquetas.Inventarios.Producto,
        CantidadDisponible: this.configService.etiquetas.Inventarios.CantidadDisponible,
        CantidadDisponibleVigente: this.configService.etiquetas.Inventarios.CantidadDisponibleVigente,
        CantidadPedidos: this.configService.etiquetas.Inventarios.CantidadPedidos,
        CantidadDisponibleVenta: this.configService.etiquetas.Inventarios.CantidadDisponibleVenta,
        IdCompania: this.configService.etiquetas.Compania,
        IdSalesOrg: this.configService.etiquetas.SalesOrg,
        FechaVencimientoLote: this.configService.etiquetas.Inventarios.FechaVencimientoLote,
        Estado: this.configService.etiquetas.Inventarios.Estado,
        IdLote: this.configService.etiquetas.Inventarios.IdLote,
        IdUnidadMedidaBase: this.configService.etiquetas.Inventarios.IdUnidadMedidaBase,
        CantidadTransito: this.configService.etiquetas.Inventarios.CantidadTransito,
        CantidadTransitoDevolucion: this.configService.etiquetas.Inventarios.CantidadTransitoDevolucion

      }

    }
    this.formControlAutocomplete = new FormControl();
    this.formControlAutocomplete.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTerm
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.filteredOptions = [];
          this.isLoading = true;
        }),
        switchMap(value => this.productosService.cDistribuidoresAutocompleteSearch(this.depositoSeleccionado.idPais, this.depositoSeleccionado.idCompania, this.depositoSeleccionado.idSalesOrg, value)
          .pipe(
            finalize(() => {
              this.isLoading = false
            }),
          )
        )
      )
      .subscribe((data: Distribuidor[]) => {
        this.filteredOptions = data;

      });
    if (this.loggedService.isInRole('DISTRIBUIDOR') || this.loggedService.isInRole('VENDEDOR')) {

      this.productosService
        .cDepositos(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg)
        .subscribe((data: Deposito[]) => {
          this.depositos = [];
          if (data.length) {
            this.depositos = data;

            const dep = this.depositos.find(d => d.cliente === true);
            if (dep) {
              this.selectedDeposito = dep;
              this.bloquearSeleccionDeposito = true;
              this.seleccionarDeposito(dep);
              if (this.loggedService.isInRole('DISTRIBUIDOR')) {
                this.productosService.cDistribuidoresAutocompleteSearch(dep.idPais,
                  dep.idCompania, dep.idSalesOrg, this.loggedService.logged.nroClienteDistribuidor).subscribe((data: Distribuidor[]) => {
                    this.distribuidorSeleccionado = data[0]

                    this.seleccionarDistribuidor()
                  });


              }


            }



          }

        })

    } else {
      this.cDepositos()
    }
  }

  cDepositos() {
    this.productosService
      .cDepositos(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg)
      .subscribe((data: Deposito[]) => {
        this.depositos = [];
        if (data.length) {
          this.depositos = data;
        }

      })
  }

  cDepositoProductos() {
    let idPais: string = "";
    let idCompania: string = "";
    let idSalesOrg: string = "";
    let idPlanta: string = "";
    let nroCliente: string = "";
    let nroClienteDireccion: string = "-1";
    let idUbicacionAlmacenamiento: string = "-1";

    if (this.depositoSeleccionado != null) {

      idPais = this.depositoSeleccionado.idPais;
      idCompania = this.depositoSeleccionado.idCompania;
      idSalesOrg = this.depositoSeleccionado.idSalesOrg;
      idPlanta = this.depositoSeleccionado.idPlanta;

      if (this.depositoSeleccionado.cliente && this.distribuidorSeleccionado != null) {
        nroCliente = this.distribuidorSeleccionado.nroCliente;
        if (this.direccionSeleccionada != null) {
          nroClienteDireccion = this.direccionSeleccionada.nroCliente
        }

      }

      if (!this.depositoSeleccionado.cliente && this.almacenSeleccionado != null) {
        idUbicacionAlmacenamiento = this.almacenSeleccionado.id;

      }
    }


    this.productosService
      .cDepositoProductos(idPais, idCompania, idSalesOrg, idPlanta, idUbicacionAlmacenamiento, nroCliente, nroClienteDireccion, "")
      .subscribe((data: Stock[]) => {
        this.dataSourcePorLote.data = [];
        this.dataSourceConsolidados.data = [];
        if (data.length) {
          this.dataSourceConsolidados.data = data;

        }

      })
  }

  seleccionarDeposito(d: any) {
    if (d == "-1") {
      this.depositoSeleccionado = d;
      this.dataSourcePorLote.data = [];
      this.dataSourceConsolidados.data = [];
      this.productoSeleccionado = null;
      this.direccionSeleccionada = null;
      this.almacenSeleccionado = null;
      this.limpiar();
    }
    else {
      if (d != this.depositoSeleccionado) {
        this.depositoSeleccionado = d;
        this.dataSourceConsolidados.data = [];
        this.productoSeleccionado = null;
        this.direccionSeleccionada = null;
        this.almacenSeleccionado = null;

        this.filteredOptions = [];
        this.dataSourcePorLote.data = [];
        this.dataSourceConsolidados.data = [];
        this.limpiar();
        if (!this.depositoSeleccionado.cliente) {
          this.productosService
            .cStoragesLocationsPlanta(this.depositoSeleccionado.idPais, this.depositoSeleccionado.idCompania, this.depositoSeleccionado.idSalesOrg, this.depositoSeleccionado.idPlanta)
            .subscribe((data: UbicacionAlmacenamiento[]) => {
              this.almacenes = [];
              if (data.length) {
                this.almacenes = data;
              }

            })

          this.cDepositoProductos();
        }
      }

    }
  }

  cDepositoProductosPorLote() {
    if (this.productoSeleccionado != null && this.depositoSeleccionado != null) {

      let idPais: string = "";
      let idCompania: string = "";
      let idSalesOrg: string = "";
      let idPlanta: string = "";
      let nroCliente: string = "";
      let nroClienteDireccion: string = "-1";
      let idProducto: string = "";
      let idUbicacionAlmacenamiento: string = "-1";

      idPais = this.depositoSeleccionado.idPais;
      idCompania = this.depositoSeleccionado.idCompania;
      idSalesOrg = this.depositoSeleccionado.idSalesOrg;
      idPlanta = this.depositoSeleccionado.idPlanta;
      idProducto = this.productoSeleccionado.idProducto;

      if (this.depositoSeleccionado.cliente && this.distribuidorSeleccionado != null) {
        nroCliente = this.distribuidorSeleccionado.nroCliente;
        if (this.direccionSeleccionada != null) {
          nroClienteDireccion = this.direccionSeleccionada.nroCliente
        }

      }
      if (!this.depositoSeleccionado.cliente && this.almacenSeleccionado != null) {
        idUbicacionAlmacenamiento = this.almacenSeleccionado.id;

      }

      this.productosService
        .cDepositoProductosPorLote(idPais, idCompania, idSalesOrg, idPlanta, idUbicacionAlmacenamiento, nroCliente, nroClienteDireccion, idProducto)
        .subscribe((data: Stock[]) => {
          this.dataSourcePorLote.data = [];
          if (data.length) {
            this.dataSourcePorLote.data = data;
          }

        })
    }
  }

  seleccionarProducto(p: Stock) {

    this.productoSeleccionado = p;
    this.cDepositoProductosPorLote();


  }

  applyFilterConsolidados(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceConsolidados.filter = filterValue.trim().toLowerCase();
  }

  applyFilterPorLote(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourcePorLote.filter = filterValue.trim().toLowerCase();
  }


  getOptionText(option) {
    return option.displayValue;
  }

  seleccionarDistribuidor() {

    if (this.distribuidorSeleccionado != null) {

      this.productosService
        .cDireccionesDistribuidor(this.distribuidorSeleccionado.idPais, this.distribuidorSeleccionado.idCompania, this.distribuidorSeleccionado.idSalesOrg, this.distribuidorSeleccionado.nroCliente, "")
        .subscribe((data: Direccion[]) => {
          this.direcciones = [];
          if (data.length) {
            this.direcciones = data;
          }

        })
      this.cDepositoProductos();
    }

  }

  seleccionarDireccion(d: any) {
    this.productoSeleccionado = null;
    if (d == "-1") {
      this.direccionSeleccionada = null;

    }
    else {
      if (this.direccionSeleccionada != d) {
        this.direccionSeleccionada = d;

      }

    }
    this.cDepositoProductos();
  }
  seleccionarAlmacen(a: any) {
    // this.depositoSeleccionado = null;
    if (a == "-1") {
      this.almacenSeleccionado = null;

    }
    else {
      if (this.almacenSeleccionado != a) {
        this.almacenSeleccionado = a;

      }

    }
    this.cDepositoProductos();
  }
  dialogStockPedidos(s: Stock) {
    if (s.listaStockPedidos.length) {
      let config: MatDialogConfig = new MatDialogConfig();
      config.width = '100%';
      config.height = 'auto';
      config.data = { s: s.listaStockPedidos }
      let dialogRef = this.dialog.open(StockPedidosDialogComponent, config);
      dialogRef.afterClosed().subscribe((data: number) => {

      })
    }
  }

  handleEmptyInput(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTerm) {
      this.distribuidorSeleccionado = null;
      this.filteredOptions = [];
    }
  }

  limpiar() {
    this.filteredOptions = [];
    this.distribuidorSeleccionado = null;
    this.direcciones = [];
    this.formControlAutocomplete.setValue('');
  }
  limpiarDistribuidor() {
    this.filteredOptions = [];
    this.distribuidorSeleccionado = null;
    this.direcciones = [];
    this.formControlAutocomplete.setValue('');
    this.dataSourcePorLote.data = [];
    this.dataSourceConsolidados.data = [];
    this.productoSeleccionado = null;
    this.direccionSeleccionada = null;
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

  cExcelDistribuidoresXCantidadDisponible() {
    var nroCliente = ''
    if (this.loggedService.isInRole('DISTRIBUIDOR')) {
      nroCliente = this.distribuidorSeleccionado.nroCliente
    }
    this.reportesSevice
      .cReporteExcelDistribuidoresXCantidadDisponible(nroCliente)
      .subscribe((reporte: StockDistribuidores[]) => {

        this.exportExcelService.cExcelReporteDistribuidoresXCantidadDisponible(reporte);

      })

  }

    cExcelDistribuidoresXLotes() {
    var nroCliente = ''
    if (this.loggedService.isInRole('DISTRIBUIDOR')) {
      nroCliente = this.distribuidorSeleccionado.nroCliente
    }
    this.reportesSevice
      .cReporteExcelDistribuidoresXLotes(nroCliente, this.loggedService.logged.idPais,  this.loggedService.logged.idCompania,  this.loggedService.logged.idSalesOrg)
      .subscribe((reporte: StockDistribuidoresLotes[]) => {

        this.exportExcelService.cExcelReporteDistribuidoresXLotes(reporte);

      })

  }
}
